import { lazy, type FC } from 'react';
import { useOrganizationApiNotificationConfig } from 'src/apis/direct-fcfs/use-notification-settings';
import { useTsoConfig } from 'src/apis/direct-fcfs/use-tso-config';
import { PageSpinner } from 'src/components/spinner-container';
import { useDirectFcfsFlags } from 'src/hooks/use-direct-fcfs-flags';
import { useTitle } from 'src/hooks/use-title';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('src/pages/settings/direct-fcfs/page'));

export const DirectFcfsSettings: FC = () => {
  const directFcfsFlags = useDirectFcfsFlags();

  if (!directFcfsFlags.data?._links?.['read-configuration'])
    throw directFcfsFlags.error || new Forbidden();

  return <DirectFcfsSettingsProtected />;
};

const DirectFcfsSettingsProtected: FC = () => {
  useTitle('Settings - Direct FCFS');
  const apiSettingsRequest = useOrganizationApiNotificationConfig();
  const tsoConfigRequest = useTsoConfig();

  if (!apiSettingsRequest.response || !tsoConfigRequest.response)
    return <PageSpinner />;

  return (
    <Page
      apiSettingsRequest={apiSettingsRequest}
      tsoConfigRequest={tsoConfigRequest}
    />
  );
};
